export const albums_data = {
   "2021-08-28-tadoussac": {
      "name": "2021.08.28 - Tadoussac",
      "photos": [
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210828221350.jpg",
            "slug": "img-20210828221350-jpg",
            "src": "/gallery/static/_gallery/albums/2021-08-28-tadoussac/1600x1043_img-20210828221350-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-08-28-tadoussac/1024x668_img-20210828221350-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-08-28-tadoussac/1600x1043_img-20210828221350-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-08-28-tadoussac/500x326_img-20210828221350-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-08-28-tadoussac/800x521_img-20210828221350-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-08-28-tadoussac/500x326_img-20210828221350-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210828221940.jpg",
            "slug": "img-20210828221940-jpg",
            "src": "/gallery/static/_gallery/albums/2021-08-28-tadoussac/1600x1043_img-20210828221940-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-08-28-tadoussac/1024x668_img-20210828221940-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-08-28-tadoussac/1600x1043_img-20210828221940-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-08-28-tadoussac/500x326_img-20210828221940-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-08-28-tadoussac/800x521_img-20210828221940-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-08-28-tadoussac/500x326_img-20210828221940-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210828224834.jpg",
            "slug": "img-20210828224834-jpg",
            "src": "/gallery/static/_gallery/albums/2021-08-28-tadoussac/1600x1043_img-20210828224834-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-08-28-tadoussac/1024x668_img-20210828224834-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-08-28-tadoussac/1600x1043_img-20210828224834-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-08-28-tadoussac/500x326_img-20210828224834-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-08-28-tadoussac/800x521_img-20210828224834-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-08-28-tadoussac/500x326_img-20210828224834-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210828225926.jpg",
            "slug": "img-20210828225926-jpg",
            "src": "/gallery/static/_gallery/albums/2021-08-28-tadoussac/1600x1043_img-20210828225926-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-08-28-tadoussac/1024x668_img-20210828225926-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-08-28-tadoussac/1600x1043_img-20210828225926-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-08-28-tadoussac/500x326_img-20210828225926-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-08-28-tadoussac/800x521_img-20210828225926-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-08-28-tadoussac/500x326_img-20210828225926-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210828230036.jpg",
            "slug": "img-20210828230036-jpg",
            "src": "/gallery/static/_gallery/albums/2021-08-28-tadoussac/1600x1043_img-20210828230036-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-08-28-tadoussac/1024x668_img-20210828230036-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-08-28-tadoussac/1600x1043_img-20210828230036-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-08-28-tadoussac/500x326_img-20210828230036-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-08-28-tadoussac/800x521_img-20210828230036-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-08-28-tadoussac/500x326_img-20210828230036-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1632,
            "name": "IMG_20210828230056.jpg",
            "slug": "img-20210828230056-jpg",
            "src": "/gallery/static/_gallery/albums/2021-08-28-tadoussac/1600x1044_img-20210828230056-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-08-28-tadoussac/1024x668_img-20210828230056-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-08-28-tadoussac/1600x1044_img-20210828230056-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-08-28-tadoussac/500x326_img-20210828230056-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-08-28-tadoussac/800x522_img-20210828230056-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-08-28-tadoussac/500x326_img-20210828230056-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210828230110.jpg",
            "slug": "img-20210828230110-jpg",
            "src": "/gallery/static/_gallery/albums/2021-08-28-tadoussac/1600x1043_img-20210828230110-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-08-28-tadoussac/1024x668_img-20210828230110-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-08-28-tadoussac/1600x1043_img-20210828230110-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-08-28-tadoussac/500x326_img-20210828230110-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-08-28-tadoussac/800x521_img-20210828230110-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-08-28-tadoussac/500x326_img-20210828230110-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210828230128.jpg",
            "slug": "img-20210828230128-jpg",
            "src": "/gallery/static/_gallery/albums/2021-08-28-tadoussac/1600x1043_img-20210828230128-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-08-28-tadoussac/1024x668_img-20210828230128-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-08-28-tadoussac/1600x1043_img-20210828230128-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-08-28-tadoussac/500x326_img-20210828230128-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-08-28-tadoussac/800x521_img-20210828230128-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-08-28-tadoussac/500x326_img-20210828230128-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210828230129.jpg",
            "slug": "img-20210828230129-jpg",
            "src": "/gallery/static/_gallery/albums/2021-08-28-tadoussac/1600x1043_img-20210828230129-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-08-28-tadoussac/1024x668_img-20210828230129-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-08-28-tadoussac/1600x1043_img-20210828230129-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-08-28-tadoussac/500x326_img-20210828230129-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-08-28-tadoussac/800x521_img-20210828230129-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-08-28-tadoussac/500x326_img-20210828230129-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210828230129_01.jpg",
            "slug": "img-20210828230129-01-jpg",
            "src": "/gallery/static/_gallery/albums/2021-08-28-tadoussac/1600x1043_img-20210828230129-01-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-08-28-tadoussac/1024x668_img-20210828230129-01-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-08-28-tadoussac/1600x1043_img-20210828230129-01-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-08-28-tadoussac/500x326_img-20210828230129-01-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-08-28-tadoussac/800x521_img-20210828230129-01-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-08-28-tadoussac/500x326_img-20210828230129-01-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210828230129_02.jpg",
            "slug": "img-20210828230129-02-jpg",
            "src": "/gallery/static/_gallery/albums/2021-08-28-tadoussac/1600x1043_img-20210828230129-02-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-08-28-tadoussac/1024x668_img-20210828230129-02-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-08-28-tadoussac/1600x1043_img-20210828230129-02-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-08-28-tadoussac/500x326_img-20210828230129-02-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-08-28-tadoussac/800x521_img-20210828230129-02-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-08-28-tadoussac/500x326_img-20210828230129-02-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210828230637.jpg",
            "slug": "img-20210828230637-jpg",
            "src": "/gallery/static/_gallery/albums/2021-08-28-tadoussac/1600x1043_img-20210828230637-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-08-28-tadoussac/1024x668_img-20210828230637-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-08-28-tadoussac/1600x1043_img-20210828230637-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-08-28-tadoussac/500x326_img-20210828230637-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-08-28-tadoussac/800x521_img-20210828230637-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-08-28-tadoussac/500x326_img-20210828230637-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210828230828.jpg",
            "slug": "img-20210828230828-jpg",
            "src": "/gallery/static/_gallery/albums/2021-08-28-tadoussac/1600x1043_img-20210828230828-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-08-28-tadoussac/1024x668_img-20210828230828-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-08-28-tadoussac/1600x1043_img-20210828230828-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-08-28-tadoussac/500x326_img-20210828230828-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-08-28-tadoussac/800x521_img-20210828230828-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-08-28-tadoussac/500x326_img-20210828230828-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210828233233.jpg",
            "slug": "img-20210828233233-jpg",
            "src": "/gallery/static/_gallery/albums/2021-08-28-tadoussac/1600x1043_img-20210828233233-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-08-28-tadoussac/1024x668_img-20210828233233-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-08-28-tadoussac/1600x1043_img-20210828233233-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-08-28-tadoussac/500x326_img-20210828233233-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-08-28-tadoussac/800x521_img-20210828233233-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-08-28-tadoussac/500x326_img-20210828233233-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210828233416.jpg",
            "slug": "img-20210828233416-jpg",
            "src": "/gallery/static/_gallery/albums/2021-08-28-tadoussac/1600x1043_img-20210828233416-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-08-28-tadoussac/1024x668_img-20210828233416-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-08-28-tadoussac/1600x1043_img-20210828233416-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-08-28-tadoussac/500x326_img-20210828233416-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-08-28-tadoussac/800x521_img-20210828233416-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-08-28-tadoussac/500x326_img-20210828233416-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210828234248.jpg",
            "slug": "img-20210828234248-jpg",
            "src": "/gallery/static/_gallery/albums/2021-08-28-tadoussac/1600x1043_img-20210828234248-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-08-28-tadoussac/1024x668_img-20210828234248-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-08-28-tadoussac/1600x1043_img-20210828234248-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-08-28-tadoussac/500x326_img-20210828234248-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-08-28-tadoussac/800x521_img-20210828234248-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-08-28-tadoussac/500x326_img-20210828234248-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210828234954.jpg",
            "slug": "img-20210828234954-jpg",
            "src": "/gallery/static/_gallery/albums/2021-08-28-tadoussac/1600x1043_img-20210828234954-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-08-28-tadoussac/1024x668_img-20210828234954-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-08-28-tadoussac/1600x1043_img-20210828234954-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-08-28-tadoussac/500x326_img-20210828234954-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-08-28-tadoussac/800x521_img-20210828234954-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-08-28-tadoussac/500x326_img-20210828234954-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210828235010.jpg",
            "slug": "img-20210828235010-jpg",
            "src": "/gallery/static/_gallery/albums/2021-08-28-tadoussac/1600x1043_img-20210828235010-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-08-28-tadoussac/1024x668_img-20210828235010-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-08-28-tadoussac/1600x1043_img-20210828235010-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-08-28-tadoussac/500x326_img-20210828235010-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-08-28-tadoussac/800x521_img-20210828235010-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-08-28-tadoussac/500x326_img-20210828235010-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210829134658.jpg",
            "slug": "img-20210829134658-jpg",
            "src": "/gallery/static/_gallery/albums/2021-08-28-tadoussac/1600x1043_img-20210829134658-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-08-28-tadoussac/1024x668_img-20210829134658-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-08-28-tadoussac/1600x1043_img-20210829134658-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-08-28-tadoussac/500x326_img-20210829134658-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-08-28-tadoussac/800x521_img-20210829134658-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-08-28-tadoussac/500x326_img-20210829134658-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210829134953.jpg",
            "slug": "img-20210829134953-jpg",
            "src": "/gallery/static/_gallery/albums/2021-08-28-tadoussac/1600x1043_img-20210829134953-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-08-28-tadoussac/1024x668_img-20210829134953-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-08-28-tadoussac/1600x1043_img-20210829134953-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-08-28-tadoussac/500x326_img-20210829134953-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-08-28-tadoussac/800x521_img-20210829134953-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-08-28-tadoussac/500x326_img-20210829134953-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210829140810.jpg",
            "slug": "img-20210829140810-jpg",
            "src": "/gallery/static/_gallery/albums/2021-08-28-tadoussac/1600x1043_img-20210829140810-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-08-28-tadoussac/1024x668_img-20210829140810-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-08-28-tadoussac/1600x1043_img-20210829140810-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-08-28-tadoussac/500x326_img-20210829140810-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-08-28-tadoussac/800x521_img-20210829140810-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-08-28-tadoussac/500x326_img-20210829140810-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210829141206.jpg",
            "slug": "img-20210829141206-jpg",
            "src": "/gallery/static/_gallery/albums/2021-08-28-tadoussac/1600x1043_img-20210829141206-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-08-28-tadoussac/1024x668_img-20210829141206-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-08-28-tadoussac/1600x1043_img-20210829141206-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-08-28-tadoussac/500x326_img-20210829141206-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-08-28-tadoussac/800x521_img-20210829141206-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-08-28-tadoussac/500x326_img-20210829141206-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210829141409.jpg",
            "slug": "img-20210829141409-jpg",
            "src": "/gallery/static/_gallery/albums/2021-08-28-tadoussac/1600x1043_img-20210829141409-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-08-28-tadoussac/1024x668_img-20210829141409-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-08-28-tadoussac/1600x1043_img-20210829141409-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-08-28-tadoussac/500x326_img-20210829141409-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-08-28-tadoussac/800x521_img-20210829141409-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-08-28-tadoussac/500x326_img-20210829141409-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 2500,
            "name": "IMG_20210829145048.jpg",
            "slug": "img-20210829145048-jpg",
            "src": "/gallery/static/_gallery/albums/2021-08-28-tadoussac/1600x2452_img-20210829145048-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-08-28-tadoussac/1024x1569_img-20210829145048-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-08-28-tadoussac/1600x2452_img-20210829145048-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-08-28-tadoussac/500x766_img-20210829145048-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-08-28-tadoussac/800x1226_img-20210829145048-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-08-28-tadoussac/500x766_img-20210829145048-jpg.jpg",
            "width": 1631
         }
      ],
      "slug": "2021-08-28-tadoussac",
      "src": "/gallery/static/_gallery/albums/2021-08-28-tadoussac/500x326_img-20210828221350-jpg.jpg"
   },
   "2021-08-30-quebec-ville": {
      "name": "2021.08.30 - Qu\u00e9bec ville",
      "photos": [
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210830190823.jpg",
            "slug": "img-20210830190823-jpg",
            "src": "/gallery/static/_gallery/albums/2021-08-30-quebec-ville/1600x1043_img-20210830190823-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-08-30-quebec-ville/1024x668_img-20210830190823-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-08-30-quebec-ville/1600x1043_img-20210830190823-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-08-30-quebec-ville/500x326_img-20210830190823-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-08-30-quebec-ville/800x521_img-20210830190823-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-08-30-quebec-ville/500x326_img-20210830190823-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210830192312.jpg",
            "slug": "img-20210830192312-jpg",
            "src": "/gallery/static/_gallery/albums/2021-08-30-quebec-ville/1600x1043_img-20210830192312-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-08-30-quebec-ville/1024x668_img-20210830192312-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-08-30-quebec-ville/1600x1043_img-20210830192312-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-08-30-quebec-ville/500x326_img-20210830192312-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-08-30-quebec-ville/800x521_img-20210830192312-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-08-30-quebec-ville/500x326_img-20210830192312-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210902115245.jpg",
            "slug": "img-20210902115245-jpg",
            "src": "/gallery/static/_gallery/albums/2021-08-30-quebec-ville/1600x1043_img-20210902115245-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-08-30-quebec-ville/1024x668_img-20210902115245-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-08-30-quebec-ville/1600x1043_img-20210902115245-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-08-30-quebec-ville/500x326_img-20210902115245-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-08-30-quebec-ville/800x521_img-20210902115245-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-08-30-quebec-ville/500x326_img-20210902115245-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210902115433.jpg",
            "slug": "img-20210902115433-jpg",
            "src": "/gallery/static/_gallery/albums/2021-08-30-quebec-ville/1600x1043_img-20210902115433-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-08-30-quebec-ville/1024x668_img-20210902115433-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-08-30-quebec-ville/1600x1043_img-20210902115433-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-08-30-quebec-ville/500x326_img-20210902115433-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-08-30-quebec-ville/800x521_img-20210902115433-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-08-30-quebec-ville/500x326_img-20210902115433-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210903203115.jpg",
            "slug": "img-20210903203115-jpg",
            "src": "/gallery/static/_gallery/albums/2021-08-30-quebec-ville/1600x1043_img-20210903203115-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-08-30-quebec-ville/1024x668_img-20210903203115-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-08-30-quebec-ville/1600x1043_img-20210903203115-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-08-30-quebec-ville/500x326_img-20210903203115-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-08-30-quebec-ville/800x521_img-20210903203115-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-08-30-quebec-ville/500x326_img-20210903203115-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210905115512.jpg",
            "slug": "img-20210905115512-jpg",
            "src": "/gallery/static/_gallery/albums/2021-08-30-quebec-ville/1600x1043_img-20210905115512-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-08-30-quebec-ville/1024x668_img-20210905115512-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-08-30-quebec-ville/1600x1043_img-20210905115512-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-08-30-quebec-ville/500x326_img-20210905115512-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-08-30-quebec-ville/800x521_img-20210905115512-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-08-30-quebec-ville/500x326_img-20210905115512-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210906145251.jpg",
            "slug": "img-20210906145251-jpg",
            "src": "/gallery/static/_gallery/albums/2021-08-30-quebec-ville/1600x1043_img-20210906145251-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-08-30-quebec-ville/1024x668_img-20210906145251-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-08-30-quebec-ville/1600x1043_img-20210906145251-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-08-30-quebec-ville/500x326_img-20210906145251-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-08-30-quebec-ville/800x521_img-20210906145251-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-08-30-quebec-ville/500x326_img-20210906145251-jpg.jpg",
            "width": 2500
         }
      ],
      "slug": "2021-08-30-quebec-ville",
      "src": "/gallery/static/_gallery/albums/2021-08-30-quebec-ville/500x326_img-20210830190823-jpg.jpg"
   },
   "2021-09-11-vancouver": {
      "name": "2021.09.11 - Vancouver",
      "photos": [
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210911133100.jpg",
            "slug": "img-20210911133100-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-11-vancouver/1600x1043_img-20210911133100-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-11-vancouver/1024x668_img-20210911133100-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-11-vancouver/1600x1043_img-20210911133100-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-11-vancouver/500x326_img-20210911133100-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-11-vancouver/800x521_img-20210911133100-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-11-vancouver/500x326_img-20210911133100-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 2500,
            "name": "IMG_20210911133748.jpg",
            "slug": "img-20210911133748-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-11-vancouver/1600x2452_img-20210911133748-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-11-vancouver/1024x1569_img-20210911133748-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-11-vancouver/1600x2452_img-20210911133748-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-11-vancouver/500x766_img-20210911133748-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-11-vancouver/800x1226_img-20210911133748-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-11-vancouver/500x766_img-20210911133748-jpg.jpg",
            "width": 1631
         },
         {
            "faces": [],
            "height": 2500,
            "name": "IMG_20210911142316.jpg",
            "slug": "img-20210911142316-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-11-vancouver/1600x2452_img-20210911142316-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-11-vancouver/1024x1569_img-20210911142316-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-11-vancouver/1600x2452_img-20210911142316-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-11-vancouver/500x766_img-20210911142316-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-11-vancouver/800x1226_img-20210911142316-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-11-vancouver/500x766_img-20210911142316-jpg.jpg",
            "width": 1631
         },
         {
            "faces": [],
            "height": 2500,
            "name": "IMG_20210912125149.jpg",
            "slug": "img-20210912125149-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-11-vancouver/1600x2452_img-20210912125149-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-11-vancouver/1024x1569_img-20210912125149-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-11-vancouver/1600x2452_img-20210912125149-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-11-vancouver/500x766_img-20210912125149-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-11-vancouver/800x1226_img-20210912125149-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-11-vancouver/500x766_img-20210912125149-jpg.jpg",
            "width": 1631
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210912130344.jpg",
            "slug": "img-20210912130344-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-11-vancouver/1600x1043_img-20210912130344-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-11-vancouver/1024x668_img-20210912130344-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-11-vancouver/1600x1043_img-20210912130344-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-11-vancouver/500x326_img-20210912130344-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-11-vancouver/800x521_img-20210912130344-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-11-vancouver/500x326_img-20210912130344-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210912144451.jpg",
            "slug": "img-20210912144451-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-11-vancouver/1600x1043_img-20210912144451-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-11-vancouver/1024x668_img-20210912144451-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-11-vancouver/1600x1043_img-20210912144451-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-11-vancouver/500x326_img-20210912144451-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-11-vancouver/800x521_img-20210912144451-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-11-vancouver/500x326_img-20210912144451-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210912144518.jpg",
            "slug": "img-20210912144518-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-11-vancouver/1600x1043_img-20210912144518-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-11-vancouver/1024x668_img-20210912144518-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-11-vancouver/1600x1043_img-20210912144518-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-11-vancouver/500x326_img-20210912144518-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-11-vancouver/800x521_img-20210912144518-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-11-vancouver/500x326_img-20210912144518-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210913131937.jpg",
            "slug": "img-20210913131937-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-11-vancouver/1600x1043_img-20210913131937-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-11-vancouver/1024x668_img-20210913131937-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-11-vancouver/1600x1043_img-20210913131937-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-11-vancouver/500x326_img-20210913131937-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-11-vancouver/800x521_img-20210913131937-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-11-vancouver/500x326_img-20210913131937-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210913132948.jpg",
            "slug": "img-20210913132948-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-11-vancouver/1600x1043_img-20210913132948-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-11-vancouver/1024x668_img-20210913132948-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-11-vancouver/1600x1043_img-20210913132948-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-11-vancouver/500x326_img-20210913132948-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-11-vancouver/800x521_img-20210913132948-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-11-vancouver/500x326_img-20210913132948-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210913134350.jpg",
            "slug": "img-20210913134350-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-11-vancouver/1600x1043_img-20210913134350-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-11-vancouver/1024x668_img-20210913134350-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-11-vancouver/1600x1043_img-20210913134350-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-11-vancouver/500x326_img-20210913134350-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-11-vancouver/800x521_img-20210913134350-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-11-vancouver/500x326_img-20210913134350-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210913140620.jpg",
            "slug": "img-20210913140620-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-11-vancouver/1600x1043_img-20210913140620-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-11-vancouver/1024x668_img-20210913140620-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-11-vancouver/1600x1043_img-20210913140620-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-11-vancouver/500x326_img-20210913140620-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-11-vancouver/800x521_img-20210913140620-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-11-vancouver/500x326_img-20210913140620-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210913141337.jpg",
            "slug": "img-20210913141337-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-11-vancouver/1600x1043_img-20210913141337-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-11-vancouver/1024x668_img-20210913141337-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-11-vancouver/1600x1043_img-20210913141337-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-11-vancouver/500x326_img-20210913141337-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-11-vancouver/800x521_img-20210913141337-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-11-vancouver/500x326_img-20210913141337-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210913143626.jpg",
            "slug": "img-20210913143626-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-11-vancouver/1600x1043_img-20210913143626-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-11-vancouver/1024x668_img-20210913143626-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-11-vancouver/1600x1043_img-20210913143626-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-11-vancouver/500x326_img-20210913143626-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-11-vancouver/800x521_img-20210913143626-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-11-vancouver/500x326_img-20210913143626-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210913144547.jpg",
            "slug": "img-20210913144547-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-11-vancouver/1600x1043_img-20210913144547-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-11-vancouver/1024x668_img-20210913144547-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-11-vancouver/1600x1043_img-20210913144547-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-11-vancouver/500x326_img-20210913144547-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-11-vancouver/800x521_img-20210913144547-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-11-vancouver/500x326_img-20210913144547-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210913154644.jpg",
            "slug": "img-20210913154644-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-11-vancouver/1600x1043_img-20210913154644-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-11-vancouver/1024x668_img-20210913154644-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-11-vancouver/1600x1043_img-20210913154644-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-11-vancouver/500x326_img-20210913154644-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-11-vancouver/800x521_img-20210913154644-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-11-vancouver/500x326_img-20210913154644-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210913170255.jpg",
            "slug": "img-20210913170255-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-11-vancouver/1600x1043_img-20210913170255-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-11-vancouver/1024x668_img-20210913170255-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-11-vancouver/1600x1043_img-20210913170255-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-11-vancouver/500x326_img-20210913170255-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-11-vancouver/800x521_img-20210913170255-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-11-vancouver/500x326_img-20210913170255-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 2500,
            "name": "IMG_20210913174212.jpg",
            "slug": "img-20210913174212-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-11-vancouver/1600x2452_img-20210913174212-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-11-vancouver/1024x1569_img-20210913174212-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-11-vancouver/1600x2452_img-20210913174212-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-11-vancouver/500x766_img-20210913174212-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-11-vancouver/800x1226_img-20210913174212-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-11-vancouver/500x766_img-20210913174212-jpg.jpg",
            "width": 1631
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210913180542.jpg",
            "slug": "img-20210913180542-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-11-vancouver/1600x1043_img-20210913180542-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-11-vancouver/1024x668_img-20210913180542-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-11-vancouver/1600x1043_img-20210913180542-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-11-vancouver/500x326_img-20210913180542-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-11-vancouver/800x521_img-20210913180542-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-11-vancouver/500x326_img-20210913180542-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210913185609.jpg",
            "slug": "img-20210913185609-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-11-vancouver/1600x1043_img-20210913185609-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-11-vancouver/1024x668_img-20210913185609-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-11-vancouver/1600x1043_img-20210913185609-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-11-vancouver/500x326_img-20210913185609-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-11-vancouver/800x521_img-20210913185609-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-11-vancouver/500x326_img-20210913185609-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210913185929.jpg",
            "slug": "img-20210913185929-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-11-vancouver/1600x1043_img-20210913185929-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-11-vancouver/1024x668_img-20210913185929-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-11-vancouver/1600x1043_img-20210913185929-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-11-vancouver/500x326_img-20210913185929-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-11-vancouver/800x521_img-20210913185929-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-11-vancouver/500x326_img-20210913185929-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210913190033.jpg",
            "slug": "img-20210913190033-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-11-vancouver/1600x1043_img-20210913190033-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-11-vancouver/1024x668_img-20210913190033-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-11-vancouver/1600x1043_img-20210913190033-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-11-vancouver/500x326_img-20210913190033-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-11-vancouver/800x521_img-20210913190033-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-11-vancouver/500x326_img-20210913190033-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210913190613.jpg",
            "slug": "img-20210913190613-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-11-vancouver/1600x1043_img-20210913190613-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-11-vancouver/1024x668_img-20210913190613-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-11-vancouver/1600x1043_img-20210913190613-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-11-vancouver/500x326_img-20210913190613-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-11-vancouver/800x521_img-20210913190613-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-11-vancouver/500x326_img-20210913190613-jpg.jpg",
            "width": 2500
         }
      ],
      "slug": "2021-09-11-vancouver",
      "src": "/gallery/static/_gallery/albums/2021-09-11-vancouver/500x326_img-20210911133100-jpg.jpg"
   },
   "2021-09-15-vancouver-island": {
      "name": "2021.09.15 - Vancouver Island",
      "photos": [
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210915132641.jpg",
            "slug": "img-20210915132641-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/1600x1043_img-20210915132641-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/1024x668_img-20210915132641-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/1600x1043_img-20210915132641-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/500x326_img-20210915132641-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/800x521_img-20210915132641-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/500x326_img-20210915132641-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210915135100.jpg",
            "slug": "img-20210915135100-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/1600x1043_img-20210915135100-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/1024x668_img-20210915135100-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/1600x1043_img-20210915135100-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/500x326_img-20210915135100-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/800x521_img-20210915135100-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/500x326_img-20210915135100-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210915174951.jpg",
            "slug": "img-20210915174951-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/1600x1043_img-20210915174951-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/1024x668_img-20210915174951-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/1600x1043_img-20210915174951-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/500x326_img-20210915174951-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/800x521_img-20210915174951-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/500x326_img-20210915174951-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210915182734.jpg",
            "slug": "img-20210915182734-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/1600x1043_img-20210915182734-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/1024x668_img-20210915182734-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/1600x1043_img-20210915182734-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/500x326_img-20210915182734-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/800x521_img-20210915182734-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/500x326_img-20210915182734-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 2500,
            "name": "IMG_20210915183207.jpg",
            "slug": "img-20210915183207-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/1600x2452_img-20210915183207-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/1024x1569_img-20210915183207-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/1600x2452_img-20210915183207-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/500x766_img-20210915183207-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/800x1226_img-20210915183207-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/500x766_img-20210915183207-jpg.jpg",
            "width": 1631
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210915185156.jpg",
            "slug": "img-20210915185156-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/1600x1043_img-20210915185156-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/1024x668_img-20210915185156-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/1600x1043_img-20210915185156-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/500x326_img-20210915185156-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/800x521_img-20210915185156-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/500x326_img-20210915185156-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210915185309.jpg",
            "slug": "img-20210915185309-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/1600x1043_img-20210915185309-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/1024x668_img-20210915185309-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/1600x1043_img-20210915185309-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/500x326_img-20210915185309-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/800x521_img-20210915185309-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/500x326_img-20210915185309-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210915194302.jpg",
            "slug": "img-20210915194302-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/1600x1043_img-20210915194302-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/1024x668_img-20210915194302-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/1600x1043_img-20210915194302-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/500x326_img-20210915194302-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/800x521_img-20210915194302-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/500x326_img-20210915194302-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210916154945.jpg",
            "slug": "img-20210916154945-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/1600x1043_img-20210916154945-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/1024x668_img-20210916154945-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/1600x1043_img-20210916154945-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/500x326_img-20210916154945-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/800x521_img-20210916154945-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/500x326_img-20210916154945-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210916160653.jpg",
            "slug": "img-20210916160653-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/1600x1043_img-20210916160653-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/1024x668_img-20210916160653-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/1600x1043_img-20210916160653-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/500x326_img-20210916160653-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/800x521_img-20210916160653-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/500x326_img-20210916160653-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210916160922.jpg",
            "slug": "img-20210916160922-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/1600x1043_img-20210916160922-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/1024x668_img-20210916160922-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/1600x1043_img-20210916160922-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/500x326_img-20210916160922-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/800x521_img-20210916160922-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/500x326_img-20210916160922-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210916173749.jpg",
            "slug": "img-20210916173749-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/1600x1043_img-20210916173749-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/1024x668_img-20210916173749-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/1600x1043_img-20210916173749-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/500x326_img-20210916173749-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/800x521_img-20210916173749-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/500x326_img-20210916173749-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210916175113.jpg",
            "slug": "img-20210916175113-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/1600x1043_img-20210916175113-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/1024x668_img-20210916175113-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/1600x1043_img-20210916175113-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/500x326_img-20210916175113-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/800x521_img-20210916175113-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/500x326_img-20210916175113-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210916175321.jpg",
            "slug": "img-20210916175321-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/1600x1043_img-20210916175321-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/1024x668_img-20210916175321-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/1600x1043_img-20210916175321-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/500x326_img-20210916175321-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/800x521_img-20210916175321-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/500x326_img-20210916175321-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210916175651.jpg",
            "slug": "img-20210916175651-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/1600x1043_img-20210916175651-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/1024x668_img-20210916175651-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/1600x1043_img-20210916175651-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/500x326_img-20210916175651-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/800x521_img-20210916175651-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/500x326_img-20210916175651-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210918125848.jpg",
            "slug": "img-20210918125848-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/1600x1043_img-20210918125848-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/1024x668_img-20210918125848-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/1600x1043_img-20210918125848-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/500x326_img-20210918125848-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/800x521_img-20210918125848-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/500x326_img-20210918125848-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210918130132.jpg",
            "slug": "img-20210918130132-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/1600x1043_img-20210918130132-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/1024x668_img-20210918130132-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/1600x1043_img-20210918130132-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/500x326_img-20210918130132-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/800x521_img-20210918130132-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/500x326_img-20210918130132-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210918130448.jpg",
            "slug": "img-20210918130448-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/1600x1043_img-20210918130448-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/1024x668_img-20210918130448-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/1600x1043_img-20210918130448-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/500x326_img-20210918130448-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/800x521_img-20210918130448-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/500x326_img-20210918130448-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210918130527.jpg",
            "slug": "img-20210918130527-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/1600x1043_img-20210918130527-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/1024x668_img-20210918130527-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/1600x1043_img-20210918130527-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/500x326_img-20210918130527-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/800x521_img-20210918130527-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/500x326_img-20210918130527-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210918130836.jpg",
            "slug": "img-20210918130836-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/1600x1043_img-20210918130836-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/1024x668_img-20210918130836-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/1600x1043_img-20210918130836-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/500x326_img-20210918130836-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/800x521_img-20210918130836-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/500x326_img-20210918130836-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210918132529.jpg",
            "slug": "img-20210918132529-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/1600x1043_img-20210918132529-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/1024x668_img-20210918132529-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/1600x1043_img-20210918132529-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/500x326_img-20210918132529-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/800x521_img-20210918132529-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/500x326_img-20210918132529-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 2500,
            "name": "IMG_20210918134039.jpg",
            "slug": "img-20210918134039-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/1600x2452_img-20210918134039-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/1024x1569_img-20210918134039-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/1600x2452_img-20210918134039-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/500x766_img-20210918134039-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/800x1226_img-20210918134039-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/500x766_img-20210918134039-jpg.jpg",
            "width": 1631
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210918134241.jpg",
            "slug": "img-20210918134241-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/1600x1043_img-20210918134241-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/1024x668_img-20210918134241-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/1600x1043_img-20210918134241-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/500x326_img-20210918134241-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/800x521_img-20210918134241-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/500x326_img-20210918134241-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210918134446.jpg",
            "slug": "img-20210918134446-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/1600x1043_img-20210918134446-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/1024x668_img-20210918134446-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/1600x1043_img-20210918134446-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/500x326_img-20210918134446-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/800x521_img-20210918134446-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/500x326_img-20210918134446-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210918135525.jpg",
            "slug": "img-20210918135525-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/1600x1043_img-20210918135525-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/1024x668_img-20210918135525-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/1600x1043_img-20210918135525-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/500x326_img-20210918135525-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/800x521_img-20210918135525-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/500x326_img-20210918135525-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210918135956.jpg",
            "slug": "img-20210918135956-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/1600x1043_img-20210918135956-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/1024x668_img-20210918135956-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/1600x1043_img-20210918135956-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/500x326_img-20210918135956-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/800x521_img-20210918135956-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/500x326_img-20210918135956-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210918140523.jpg",
            "slug": "img-20210918140523-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/1600x1043_img-20210918140523-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/1024x668_img-20210918140523-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/1600x1043_img-20210918140523-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/500x326_img-20210918140523-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/800x521_img-20210918140523-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/500x326_img-20210918140523-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210918141258.jpg",
            "slug": "img-20210918141258-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/1600x1043_img-20210918141258-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/1024x668_img-20210918141258-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/1600x1043_img-20210918141258-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/500x326_img-20210918141258-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/800x521_img-20210918141258-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/500x326_img-20210918141258-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210918145029.jpg",
            "slug": "img-20210918145029-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/1600x1043_img-20210918145029-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/1024x668_img-20210918145029-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/1600x1043_img-20210918145029-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/500x326_img-20210918145029-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/800x521_img-20210918145029-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/500x326_img-20210918145029-jpg.jpg",
            "width": 2500
         }
      ],
      "slug": "2021-09-15-vancouver-island",
      "src": "/gallery/static/_gallery/albums/2021-09-15-vancouver-island/500x326_img-20210915132641-jpg.jpg"
   },
   "2021-09-22-bella-coola": {
      "name": "2021.09.22 - Bella Coola",
      "photos": [
         {
            "faces": [],
            "height": 1526,
            "name": "IMG_20210922102504.jpg",
            "slug": "img-20210922102504-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x976_img-20210922102504-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1024x625_img-20210922102504-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x976_img-20210922102504-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x305_img-20210922102504-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/800x488_img-20210922102504-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x305_img-20210922102504-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210922103138.jpg",
            "slug": "img-20210922103138-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x1043_img-20210922103138-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1024x668_img-20210922103138-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x1043_img-20210922103138-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x326_img-20210922103138-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/800x521_img-20210922103138-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x326_img-20210922103138-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210922111431.jpg",
            "slug": "img-20210922111431-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x1043_img-20210922111431-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1024x668_img-20210922111431-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x1043_img-20210922111431-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x326_img-20210922111431-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/800x521_img-20210922111431-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x326_img-20210922111431-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210922143321.jpg",
            "slug": "img-20210922143321-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x1043_img-20210922143321-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1024x668_img-20210922143321-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x1043_img-20210922143321-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x326_img-20210922143321-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/800x521_img-20210922143321-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x326_img-20210922143321-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210922143549.jpg",
            "slug": "img-20210922143549-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x1043_img-20210922143549-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1024x668_img-20210922143549-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x1043_img-20210922143549-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x326_img-20210922143549-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/800x521_img-20210922143549-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x326_img-20210922143549-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210922144210.jpg",
            "slug": "img-20210922144210-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x1043_img-20210922144210-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1024x668_img-20210922144210-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x1043_img-20210922144210-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x326_img-20210922144210-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/800x521_img-20210922144210-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x326_img-20210922144210-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210922161239.jpg",
            "slug": "img-20210922161239-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x1043_img-20210922161239-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1024x668_img-20210922161239-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x1043_img-20210922161239-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x326_img-20210922161239-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/800x521_img-20210922161239-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x326_img-20210922161239-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210922180721.jpg",
            "slug": "img-20210922180721-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x1043_img-20210922180721-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1024x668_img-20210922180721-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x1043_img-20210922180721-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x326_img-20210922180721-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/800x521_img-20210922180721-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x326_img-20210922180721-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210922181142.jpg",
            "slug": "img-20210922181142-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x1043_img-20210922181142-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1024x668_img-20210922181142-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x1043_img-20210922181142-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x326_img-20210922181142-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/800x521_img-20210922181142-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x326_img-20210922181142-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210922182426.jpg",
            "slug": "img-20210922182426-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x1043_img-20210922182426-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1024x668_img-20210922182426-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x1043_img-20210922182426-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x326_img-20210922182426-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/800x521_img-20210922182426-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x326_img-20210922182426-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210922183916.jpg",
            "slug": "img-20210922183916-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x1043_img-20210922183916-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1024x668_img-20210922183916-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x1043_img-20210922183916-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x326_img-20210922183916-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/800x521_img-20210922183916-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x326_img-20210922183916-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210922191707.jpg",
            "slug": "img-20210922191707-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x1043_img-20210922191707-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1024x668_img-20210922191707-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x1043_img-20210922191707-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x326_img-20210922191707-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/800x521_img-20210922191707-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x326_img-20210922191707-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210922192943.jpg",
            "slug": "img-20210922192943-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x1043_img-20210922192943-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1024x668_img-20210922192943-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x1043_img-20210922192943-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x326_img-20210922192943-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/800x521_img-20210922192943-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x326_img-20210922192943-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210922200134.jpg",
            "slug": "img-20210922200134-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x1043_img-20210922200134-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1024x668_img-20210922200134-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x1043_img-20210922200134-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x326_img-20210922200134-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/800x521_img-20210922200134-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x326_img-20210922200134-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210922200528.jpg",
            "slug": "img-20210922200528-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x1043_img-20210922200528-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1024x668_img-20210922200528-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x1043_img-20210922200528-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x326_img-20210922200528-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/800x521_img-20210922200528-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x326_img-20210922200528-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210922201222.jpg",
            "slug": "img-20210922201222-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x1043_img-20210922201222-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1024x668_img-20210922201222-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x1043_img-20210922201222-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x326_img-20210922201222-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/800x521_img-20210922201222-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x326_img-20210922201222-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 2500,
            "name": "IMG_20210924144828.jpg",
            "slug": "img-20210924144828-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x2452_img-20210924144828-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1024x1569_img-20210924144828-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x2452_img-20210924144828-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x766_img-20210924144828-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/800x1226_img-20210924144828-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x766_img-20210924144828-jpg.jpg",
            "width": 1631
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210924145740.jpg",
            "slug": "img-20210924145740-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x1043_img-20210924145740-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1024x668_img-20210924145740-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x1043_img-20210924145740-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x326_img-20210924145740-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/800x521_img-20210924145740-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x326_img-20210924145740-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210924145952.jpg",
            "slug": "img-20210924145952-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x1043_img-20210924145952-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1024x668_img-20210924145952-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x1043_img-20210924145952-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x326_img-20210924145952-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/800x521_img-20210924145952-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x326_img-20210924145952-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210924160131.jpg",
            "slug": "img-20210924160131-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x1043_img-20210924160131-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1024x668_img-20210924160131-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x1043_img-20210924160131-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x326_img-20210924160131-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/800x521_img-20210924160131-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x326_img-20210924160131-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210924160158.jpg",
            "slug": "img-20210924160158-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x1043_img-20210924160158-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1024x668_img-20210924160158-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x1043_img-20210924160158-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x326_img-20210924160158-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/800x521_img-20210924160158-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x326_img-20210924160158-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210924174707.jpg",
            "slug": "img-20210924174707-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x1043_img-20210924174707-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1024x668_img-20210924174707-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x1043_img-20210924174707-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x326_img-20210924174707-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/800x521_img-20210924174707-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x326_img-20210924174707-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210924175056.jpg",
            "slug": "img-20210924175056-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x1043_img-20210924175056-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1024x668_img-20210924175056-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x1043_img-20210924175056-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x326_img-20210924175056-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/800x521_img-20210924175056-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x326_img-20210924175056-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210924183448.jpg",
            "slug": "img-20210924183448-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x1043_img-20210924183448-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1024x668_img-20210924183448-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x1043_img-20210924183448-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x326_img-20210924183448-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/800x521_img-20210924183448-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x326_img-20210924183448-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210924183526.jpg",
            "slug": "img-20210924183526-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x1043_img-20210924183526-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1024x668_img-20210924183526-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x1043_img-20210924183526-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x326_img-20210924183526-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/800x521_img-20210924183526-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x326_img-20210924183526-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210924184452.jpg",
            "slug": "img-20210924184452-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x1043_img-20210924184452-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1024x668_img-20210924184452-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x1043_img-20210924184452-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x326_img-20210924184452-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/800x521_img-20210924184452-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x326_img-20210924184452-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210927150141.jpg",
            "slug": "img-20210927150141-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x1043_img-20210927150141-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1024x668_img-20210927150141-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x1043_img-20210927150141-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x326_img-20210927150141-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/800x521_img-20210927150141-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x326_img-20210927150141-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210927150410.jpg",
            "slug": "img-20210927150410-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x1043_img-20210927150410-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1024x668_img-20210927150410-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x1043_img-20210927150410-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x326_img-20210927150410-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/800x521_img-20210927150410-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x326_img-20210927150410-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210929130940.jpg",
            "slug": "img-20210929130940-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x1043_img-20210929130940-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1024x668_img-20210929130940-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x1043_img-20210929130940-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x326_img-20210929130940-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/800x521_img-20210929130940-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x326_img-20210929130940-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210929131004.jpg",
            "slug": "img-20210929131004-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x1043_img-20210929131004-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1024x668_img-20210929131004-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x1043_img-20210929131004-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x326_img-20210929131004-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/800x521_img-20210929131004-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x326_img-20210929131004-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210929143134.jpg",
            "slug": "img-20210929143134-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x1043_img-20210929143134-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1024x668_img-20210929143134-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x1043_img-20210929143134-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x326_img-20210929143134-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/800x521_img-20210929143134-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x326_img-20210929143134-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210929163122.jpg",
            "slug": "img-20210929163122-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x1043_img-20210929163122-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1024x668_img-20210929163122-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x1043_img-20210929163122-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x326_img-20210929163122-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/800x521_img-20210929163122-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x326_img-20210929163122-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 2500,
            "name": "IMG_20210929163218.jpg",
            "slug": "img-20210929163218-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x2452_img-20210929163218-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1024x1569_img-20210929163218-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x2452_img-20210929163218-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x766_img-20210929163218-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/800x1226_img-20210929163218-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x766_img-20210929163218-jpg.jpg",
            "width": 1631
         },
         {
            "faces": [],
            "height": 2500,
            "name": "IMG_20210929165022.jpg",
            "slug": "img-20210929165022-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x2452_img-20210929165022-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1024x1569_img-20210929165022-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x2452_img-20210929165022-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x766_img-20210929165022-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/800x1226_img-20210929165022-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x766_img-20210929165022-jpg.jpg",
            "width": 1631
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210929165735.jpg",
            "slug": "img-20210929165735-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x1043_img-20210929165735-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1024x668_img-20210929165735-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x1043_img-20210929165735-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x326_img-20210929165735-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/800x521_img-20210929165735-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x326_img-20210929165735-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210929171803.jpg",
            "slug": "img-20210929171803-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x1043_img-20210929171803-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1024x668_img-20210929171803-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x1043_img-20210929171803-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x326_img-20210929171803-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/800x521_img-20210929171803-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x326_img-20210929171803-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210929172420.jpg",
            "slug": "img-20210929172420-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x1043_img-20210929172420-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1024x668_img-20210929172420-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x1043_img-20210929172420-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x326_img-20210929172420-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/800x521_img-20210929172420-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x326_img-20210929172420-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 2500,
            "name": "IMG_20210929182721.jpg",
            "slug": "img-20210929182721-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x2452_img-20210929182721-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1024x1569_img-20210929182721-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x2452_img-20210929182721-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x766_img-20210929182721-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/800x1226_img-20210929182721-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x766_img-20210929182721-jpg.jpg",
            "width": 1631
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20210929182838.jpg",
            "slug": "img-20210929182838-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x1043_img-20210929182838-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1024x668_img-20210929182838-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x1043_img-20210929182838-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x326_img-20210929182838-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/800x521_img-20210929182838-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x326_img-20210929182838-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20211001124939.jpg",
            "slug": "img-20211001124939-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x1043_img-20211001124939-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1024x668_img-20211001124939-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x1043_img-20211001124939-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x326_img-20211001124939-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/800x521_img-20211001124939-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x326_img-20211001124939-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 2500,
            "name": "IMG_20211001125924.jpg",
            "slug": "img-20211001125924-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x2452_img-20211001125924-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1024x1569_img-20211001125924-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x2452_img-20211001125924-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x766_img-20211001125924-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/800x1226_img-20211001125924-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x766_img-20211001125924-jpg.jpg",
            "width": 1631
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20211001131427.jpg",
            "slug": "img-20211001131427-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x1043_img-20211001131427-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1024x668_img-20211001131427-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x1043_img-20211001131427-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x326_img-20211001131427-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/800x521_img-20211001131427-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x326_img-20211001131427-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20211001134042.jpg",
            "slug": "img-20211001134042-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x1043_img-20211001134042-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1024x668_img-20211001134042-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x1043_img-20211001134042-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x326_img-20211001134042-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/800x521_img-20211001134042-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x326_img-20211001134042-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20211001142001.jpg",
            "slug": "img-20211001142001-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x1043_img-20211001142001-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1024x668_img-20211001142001-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x1043_img-20211001142001-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x326_img-20211001142001-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/800x521_img-20211001142001-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x326_img-20211001142001-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20211001142658.jpg",
            "slug": "img-20211001142658-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x1043_img-20211001142658-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1024x668_img-20211001142658-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x1043_img-20211001142658-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x326_img-20211001142658-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/800x521_img-20211001142658-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x326_img-20211001142658-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20211001142802.jpg",
            "slug": "img-20211001142802-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x1043_img-20211001142802-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1024x668_img-20211001142802-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x1043_img-20211001142802-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x326_img-20211001142802-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/800x521_img-20211001142802-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x326_img-20211001142802-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20211001145038.jpg",
            "slug": "img-20211001145038-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x1043_img-20211001145038-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1024x668_img-20211001145038-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x1043_img-20211001145038-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x326_img-20211001145038-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/800x521_img-20211001145038-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x326_img-20211001145038-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20211001145254.jpg",
            "slug": "img-20211001145254-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x1043_img-20211001145254-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1024x668_img-20211001145254-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x1043_img-20211001145254-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x326_img-20211001145254-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/800x521_img-20211001145254-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x326_img-20211001145254-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20211001171650.jpg",
            "slug": "img-20211001171650-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x1043_img-20211001171650-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1024x668_img-20211001171650-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x1043_img-20211001171650-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x326_img-20211001171650-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/800x521_img-20211001171650-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x326_img-20211001171650-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20211001173846.jpg",
            "slug": "img-20211001173846-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x1043_img-20211001173846-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1024x668_img-20211001173846-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x1043_img-20211001173846-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x326_img-20211001173846-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/800x521_img-20211001173846-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x326_img-20211001173846-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20211001200707.jpg",
            "slug": "img-20211001200707-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x1043_img-20211001200707-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1024x668_img-20211001200707-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x1043_img-20211001200707-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x326_img-20211001200707-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/800x521_img-20211001200707-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x326_img-20211001200707-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20211001200906.jpg",
            "slug": "img-20211001200906-jpg",
            "src": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x1043_img-20211001200906-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1024x668_img-20211001200906-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/1600x1043_img-20211001200906-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x326_img-20211001200906-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-09-22-bella-coola/800x521_img-20211001200906-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x326_img-20211001200906-jpg.jpg",
            "width": 2500
         }
      ],
      "slug": "2021-09-22-bella-coola",
      "src": "/gallery/static/_gallery/albums/2021-09-22-bella-coola/500x305_img-20210922102504-jpg.jpg"
   },
   "2021-10-11-owl-s-head": {
      "name": "2021.10.11 - Owl's Head",
      "photos": [
         {
            "faces": [],
            "height": 2500,
            "name": "IMG_20211011115004.jpg",
            "slug": "img-20211011115004-jpg",
            "src": "/gallery/static/_gallery/albums/2021-10-11-owl-s-head/1600x2450_img-20211011115004-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-10-11-owl-s-head/1024x1568_img-20211011115004-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-10-11-owl-s-head/1600x2450_img-20211011115004-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-10-11-owl-s-head/500x765_img-20211011115004-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-10-11-owl-s-head/800x1225_img-20211011115004-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-10-11-owl-s-head/500x765_img-20211011115004-jpg.jpg",
            "width": 1632
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20211011115536.jpg",
            "slug": "img-20211011115536-jpg",
            "src": "/gallery/static/_gallery/albums/2021-10-11-owl-s-head/1600x1043_img-20211011115536-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-10-11-owl-s-head/1024x668_img-20211011115536-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-10-11-owl-s-head/1600x1043_img-20211011115536-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-10-11-owl-s-head/500x326_img-20211011115536-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-10-11-owl-s-head/800x521_img-20211011115536-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-10-11-owl-s-head/500x326_img-20211011115536-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20211011122651.jpg",
            "slug": "img-20211011122651-jpg",
            "src": "/gallery/static/_gallery/albums/2021-10-11-owl-s-head/1600x1043_img-20211011122651-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-10-11-owl-s-head/1024x668_img-20211011122651-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-10-11-owl-s-head/1600x1043_img-20211011122651-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-10-11-owl-s-head/500x326_img-20211011122651-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-10-11-owl-s-head/800x521_img-20211011122651-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-10-11-owl-s-head/500x326_img-20211011122651-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20211011135721.jpg",
            "slug": "img-20211011135721-jpg",
            "src": "/gallery/static/_gallery/albums/2021-10-11-owl-s-head/1600x1043_img-20211011135721-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-10-11-owl-s-head/1024x668_img-20211011135721-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-10-11-owl-s-head/1600x1043_img-20211011135721-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-10-11-owl-s-head/500x326_img-20211011135721-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-10-11-owl-s-head/800x521_img-20211011135721-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-10-11-owl-s-head/500x326_img-20211011135721-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20211011142232.jpg",
            "slug": "img-20211011142232-jpg",
            "src": "/gallery/static/_gallery/albums/2021-10-11-owl-s-head/1600x1043_img-20211011142232-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-10-11-owl-s-head/1024x668_img-20211011142232-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-10-11-owl-s-head/1600x1043_img-20211011142232-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-10-11-owl-s-head/500x326_img-20211011142232-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-10-11-owl-s-head/800x521_img-20211011142232-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-10-11-owl-s-head/500x326_img-20211011142232-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20211011160756.jpg",
            "slug": "img-20211011160756-jpg",
            "src": "/gallery/static/_gallery/albums/2021-10-11-owl-s-head/1600x1043_img-20211011160756-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-10-11-owl-s-head/1024x668_img-20211011160756-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-10-11-owl-s-head/1600x1043_img-20211011160756-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-10-11-owl-s-head/500x326_img-20211011160756-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-10-11-owl-s-head/800x521_img-20211011160756-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-10-11-owl-s-head/500x326_img-20211011160756-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20211011160814.jpg",
            "slug": "img-20211011160814-jpg",
            "src": "/gallery/static/_gallery/albums/2021-10-11-owl-s-head/1600x1043_img-20211011160814-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-10-11-owl-s-head/1024x668_img-20211011160814-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-10-11-owl-s-head/1600x1043_img-20211011160814-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-10-11-owl-s-head/500x326_img-20211011160814-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-10-11-owl-s-head/800x521_img-20211011160814-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-10-11-owl-s-head/500x326_img-20211011160814-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20211011163423.jpg",
            "slug": "img-20211011163423-jpg",
            "src": "/gallery/static/_gallery/albums/2021-10-11-owl-s-head/1600x1043_img-20211011163423-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-10-11-owl-s-head/1024x668_img-20211011163423-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-10-11-owl-s-head/1600x1043_img-20211011163423-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-10-11-owl-s-head/500x326_img-20211011163423-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-10-11-owl-s-head/800x521_img-20211011163423-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-10-11-owl-s-head/500x326_img-20211011163423-jpg.jpg",
            "width": 2500
         }
      ],
      "slug": "2021-10-11-owl-s-head",
      "src": "/gallery/static/_gallery/albums/2021-10-11-owl-s-head/500x765_img-20211011115004-jpg.jpg"
   },
   "2021-10-23-jardin-botanique-montreal": {
      "name": "2021.10.23 - Jardin botanique Montr\u00e9al",
      "photos": [
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20211023151242.jpg",
            "slug": "img-20211023151242-jpg",
            "src": "/gallery/static/_gallery/albums/2021-10-23-jardin-botanique-montreal/1600x1043_img-20211023151242-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-10-23-jardin-botanique-montreal/1024x668_img-20211023151242-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-10-23-jardin-botanique-montreal/1600x1043_img-20211023151242-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-10-23-jardin-botanique-montreal/500x326_img-20211023151242-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-10-23-jardin-botanique-montreal/800x521_img-20211023151242-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-10-23-jardin-botanique-montreal/500x326_img-20211023151242-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 2500,
            "name": "IMG_20211023151821.jpg",
            "slug": "img-20211023151821-jpg",
            "src": "/gallery/static/_gallery/albums/2021-10-23-jardin-botanique-montreal/1600x2452_img-20211023151821-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-10-23-jardin-botanique-montreal/1024x1569_img-20211023151821-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-10-23-jardin-botanique-montreal/1600x2452_img-20211023151821-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-10-23-jardin-botanique-montreal/500x766_img-20211023151821-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-10-23-jardin-botanique-montreal/800x1226_img-20211023151821-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-10-23-jardin-botanique-montreal/500x766_img-20211023151821-jpg.jpg",
            "width": 1631
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20211023152218.jpg",
            "slug": "img-20211023152218-jpg",
            "src": "/gallery/static/_gallery/albums/2021-10-23-jardin-botanique-montreal/1600x1043_img-20211023152218-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-10-23-jardin-botanique-montreal/1024x668_img-20211023152218-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-10-23-jardin-botanique-montreal/1600x1043_img-20211023152218-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-10-23-jardin-botanique-montreal/500x326_img-20211023152218-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-10-23-jardin-botanique-montreal/800x521_img-20211023152218-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-10-23-jardin-botanique-montreal/500x326_img-20211023152218-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20211023154708.jpg",
            "slug": "img-20211023154708-jpg",
            "src": "/gallery/static/_gallery/albums/2021-10-23-jardin-botanique-montreal/1600x1043_img-20211023154708-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-10-23-jardin-botanique-montreal/1024x668_img-20211023154708-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-10-23-jardin-botanique-montreal/1600x1043_img-20211023154708-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-10-23-jardin-botanique-montreal/500x326_img-20211023154708-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-10-23-jardin-botanique-montreal/800x521_img-20211023154708-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-10-23-jardin-botanique-montreal/500x326_img-20211023154708-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20211023155254.jpg",
            "slug": "img-20211023155254-jpg",
            "src": "/gallery/static/_gallery/albums/2021-10-23-jardin-botanique-montreal/1600x1043_img-20211023155254-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-10-23-jardin-botanique-montreal/1024x668_img-20211023155254-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-10-23-jardin-botanique-montreal/1600x1043_img-20211023155254-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-10-23-jardin-botanique-montreal/500x326_img-20211023155254-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-10-23-jardin-botanique-montreal/800x521_img-20211023155254-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-10-23-jardin-botanique-montreal/500x326_img-20211023155254-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20211023155703.jpg",
            "slug": "img-20211023155703-jpg",
            "src": "/gallery/static/_gallery/albums/2021-10-23-jardin-botanique-montreal/1600x1043_img-20211023155703-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-10-23-jardin-botanique-montreal/1024x668_img-20211023155703-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-10-23-jardin-botanique-montreal/1600x1043_img-20211023155703-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-10-23-jardin-botanique-montreal/500x326_img-20211023155703-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-10-23-jardin-botanique-montreal/800x521_img-20211023155703-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-10-23-jardin-botanique-montreal/500x326_img-20211023155703-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20211023160026.jpg",
            "slug": "img-20211023160026-jpg",
            "src": "/gallery/static/_gallery/albums/2021-10-23-jardin-botanique-montreal/1600x1043_img-20211023160026-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-10-23-jardin-botanique-montreal/1024x668_img-20211023160026-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-10-23-jardin-botanique-montreal/1600x1043_img-20211023160026-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-10-23-jardin-botanique-montreal/500x326_img-20211023160026-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-10-23-jardin-botanique-montreal/800x521_img-20211023160026-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-10-23-jardin-botanique-montreal/500x326_img-20211023160026-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20211023160135.jpg",
            "slug": "img-20211023160135-jpg",
            "src": "/gallery/static/_gallery/albums/2021-10-23-jardin-botanique-montreal/1600x1043_img-20211023160135-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-10-23-jardin-botanique-montreal/1024x668_img-20211023160135-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-10-23-jardin-botanique-montreal/1600x1043_img-20211023160135-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-10-23-jardin-botanique-montreal/500x326_img-20211023160135-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-10-23-jardin-botanique-montreal/800x521_img-20211023160135-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-10-23-jardin-botanique-montreal/500x326_img-20211023160135-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20211023160446.jpg",
            "slug": "img-20211023160446-jpg",
            "src": "/gallery/static/_gallery/albums/2021-10-23-jardin-botanique-montreal/1600x1043_img-20211023160446-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-10-23-jardin-botanique-montreal/1024x668_img-20211023160446-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-10-23-jardin-botanique-montreal/1600x1043_img-20211023160446-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-10-23-jardin-botanique-montreal/500x326_img-20211023160446-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-10-23-jardin-botanique-montreal/800x521_img-20211023160446-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-10-23-jardin-botanique-montreal/500x326_img-20211023160446-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20211023161804.jpg",
            "slug": "img-20211023161804-jpg",
            "src": "/gallery/static/_gallery/albums/2021-10-23-jardin-botanique-montreal/1600x1043_img-20211023161804-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-10-23-jardin-botanique-montreal/1024x668_img-20211023161804-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-10-23-jardin-botanique-montreal/1600x1043_img-20211023161804-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-10-23-jardin-botanique-montreal/500x326_img-20211023161804-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-10-23-jardin-botanique-montreal/800x521_img-20211023161804-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-10-23-jardin-botanique-montreal/500x326_img-20211023161804-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20211023162034.jpg",
            "slug": "img-20211023162034-jpg",
            "src": "/gallery/static/_gallery/albums/2021-10-23-jardin-botanique-montreal/1600x1043_img-20211023162034-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-10-23-jardin-botanique-montreal/1024x668_img-20211023162034-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-10-23-jardin-botanique-montreal/1600x1043_img-20211023162034-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-10-23-jardin-botanique-montreal/500x326_img-20211023162034-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-10-23-jardin-botanique-montreal/800x521_img-20211023162034-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-10-23-jardin-botanique-montreal/500x326_img-20211023162034-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20211023162810.jpg",
            "slug": "img-20211023162810-jpg",
            "src": "/gallery/static/_gallery/albums/2021-10-23-jardin-botanique-montreal/1600x1043_img-20211023162810-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-10-23-jardin-botanique-montreal/1024x668_img-20211023162810-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-10-23-jardin-botanique-montreal/1600x1043_img-20211023162810-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-10-23-jardin-botanique-montreal/500x326_img-20211023162810-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-10-23-jardin-botanique-montreal/800x521_img-20211023162810-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-10-23-jardin-botanique-montreal/500x326_img-20211023162810-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20211023162940.jpg",
            "slug": "img-20211023162940-jpg",
            "src": "/gallery/static/_gallery/albums/2021-10-23-jardin-botanique-montreal/1600x1043_img-20211023162940-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-10-23-jardin-botanique-montreal/1024x668_img-20211023162940-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-10-23-jardin-botanique-montreal/1600x1043_img-20211023162940-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-10-23-jardin-botanique-montreal/500x326_img-20211023162940-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-10-23-jardin-botanique-montreal/800x521_img-20211023162940-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-10-23-jardin-botanique-montreal/500x326_img-20211023162940-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20211023170237.jpg",
            "slug": "img-20211023170237-jpg",
            "src": "/gallery/static/_gallery/albums/2021-10-23-jardin-botanique-montreal/1600x1043_img-20211023170237-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-10-23-jardin-botanique-montreal/1024x668_img-20211023170237-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-10-23-jardin-botanique-montreal/1600x1043_img-20211023170237-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-10-23-jardin-botanique-montreal/500x326_img-20211023170237-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-10-23-jardin-botanique-montreal/800x521_img-20211023170237-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-10-23-jardin-botanique-montreal/500x326_img-20211023170237-jpg.jpg",
            "width": 2500
         },
         {
            "faces": [],
            "height": 1631,
            "name": "IMG_20211023170447.jpg",
            "slug": "img-20211023170447-jpg",
            "src": "/gallery/static/_gallery/albums/2021-10-23-jardin-botanique-montreal/1600x1043_img-20211023170447-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2021-10-23-jardin-botanique-montreal/1024x668_img-20211023170447-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2021-10-23-jardin-botanique-montreal/1600x1043_img-20211023170447-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2021-10-23-jardin-botanique-montreal/500x326_img-20211023170447-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2021-10-23-jardin-botanique-montreal/800x521_img-20211023170447-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2021-10-23-jardin-botanique-montreal/500x326_img-20211023170447-jpg.jpg",
            "width": 2500
         }
      ],
      "slug": "2021-10-23-jardin-botanique-montreal",
      "src": "/gallery/static/_gallery/albums/2021-10-23-jardin-botanique-montreal/500x326_img-20211023151242-jpg.jpg"
   },
   "2025-12-acores": {
      "name": "2025.12 - A\u00e7ores",
      "photos": [
         {
            "faces": [],
            "height": 2001,
            "name": "793A2129.jpg",
            "slug": "793a2129-jpg",
            "src": "/gallery/static/_gallery/albums/2025-12-acores/1600x1067_793a2129-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/1024x683_793a2129-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/1600x1067_793a2129-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/500x333_793a2129-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/800x533_793a2129-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2025-12-acores/500x333_793a2129-jpg.jpg",
            "width": 3000
         },
         {
            "faces": [],
            "height": 2001,
            "name": "793A2131.jpg",
            "slug": "793a2131-jpg",
            "src": "/gallery/static/_gallery/albums/2025-12-acores/1600x1067_793a2131-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/1024x683_793a2131-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/1600x1067_793a2131-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/500x333_793a2131-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/800x533_793a2131-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2025-12-acores/500x333_793a2131-jpg.jpg",
            "width": 3000
         },
         {
            "faces": [],
            "height": 2001,
            "name": "793A2134.jpg",
            "slug": "793a2134-jpg",
            "src": "/gallery/static/_gallery/albums/2025-12-acores/1600x1067_793a2134-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/1024x683_793a2134-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/1600x1067_793a2134-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/500x333_793a2134-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/800x533_793a2134-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2025-12-acores/500x333_793a2134-jpg.jpg",
            "width": 3000
         },
         {
            "faces": [],
            "height": 2001,
            "name": "793A2135.jpg",
            "slug": "793a2135-jpg",
            "src": "/gallery/static/_gallery/albums/2025-12-acores/1600x1067_793a2135-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/1024x683_793a2135-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/1600x1067_793a2135-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/500x333_793a2135-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/800x533_793a2135-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2025-12-acores/500x333_793a2135-jpg.jpg",
            "width": 3000
         },
         {
            "faces": [],
            "height": 2001,
            "name": "793A2138.jpg",
            "slug": "793a2138-jpg",
            "src": "/gallery/static/_gallery/albums/2025-12-acores/1600x1067_793a2138-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/1024x683_793a2138-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/1600x1067_793a2138-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/500x333_793a2138-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/800x533_793a2138-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2025-12-acores/500x333_793a2138-jpg.jpg",
            "width": 3000
         },
         {
            "faces": [],
            "height": 2001,
            "name": "793A2139.jpg",
            "slug": "793a2139-jpg",
            "src": "/gallery/static/_gallery/albums/2025-12-acores/1600x1067_793a2139-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/1024x683_793a2139-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/1600x1067_793a2139-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/500x333_793a2139-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/800x533_793a2139-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2025-12-acores/500x333_793a2139-jpg.jpg",
            "width": 3000
         },
         {
            "faces": [],
            "height": 3000,
            "name": "793A2144.jpg",
            "slug": "793a2144-jpg",
            "src": "/gallery/static/_gallery/albums/2025-12-acores/1599x2398_793a2144-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/1024x1535_793a2144-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/1599x2398_793a2144-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/500x749_793a2144-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/799x1199_793a2144-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2025-12-acores/500x749_793a2144-jpg.jpg",
            "width": 2001
         },
         {
            "faces": [],
            "height": 3000,
            "name": "793A2146.jpg",
            "slug": "793a2146-jpg",
            "src": "/gallery/static/_gallery/albums/2025-12-acores/1599x2398_793a2146-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/1024x1535_793a2146-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/1599x2398_793a2146-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/500x749_793a2146-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/799x1199_793a2146-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2025-12-acores/500x749_793a2146-jpg.jpg",
            "width": 2001
         },
         {
            "faces": [],
            "height": 3000,
            "name": "793A2153.jpg",
            "slug": "793a2153-jpg",
            "src": "/gallery/static/_gallery/albums/2025-12-acores/1599x2398_793a2153-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/1024x1535_793a2153-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/1599x2398_793a2153-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/500x749_793a2153-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/799x1199_793a2153-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2025-12-acores/500x749_793a2153-jpg.jpg",
            "width": 2001
         },
         {
            "faces": [],
            "height": 3000,
            "name": "793A2159.jpg",
            "slug": "793a2159-jpg",
            "src": "/gallery/static/_gallery/albums/2025-12-acores/1599x2398_793a2159-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/1024x1535_793a2159-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/1599x2398_793a2159-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/500x749_793a2159-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/799x1199_793a2159-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2025-12-acores/500x749_793a2159-jpg.jpg",
            "width": 2001
         },
         {
            "faces": [],
            "height": 2001,
            "name": "793A2161.jpg",
            "slug": "793a2161-jpg",
            "src": "/gallery/static/_gallery/albums/2025-12-acores/1600x1067_793a2161-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/1024x683_793a2161-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/1600x1067_793a2161-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/500x333_793a2161-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/800x533_793a2161-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2025-12-acores/500x333_793a2161-jpg.jpg",
            "width": 3000
         },
         {
            "faces": [],
            "height": 2001,
            "name": "793A2166.jpg",
            "slug": "793a2166-jpg",
            "src": "/gallery/static/_gallery/albums/2025-12-acores/1600x1067_793a2166-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/1024x683_793a2166-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/1600x1067_793a2166-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/500x333_793a2166-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/800x533_793a2166-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2025-12-acores/500x333_793a2166-jpg.jpg",
            "width": 3000
         },
         {
            "faces": [],
            "height": 3000,
            "name": "793A2172.jpg",
            "slug": "793a2172-jpg",
            "src": "/gallery/static/_gallery/albums/2025-12-acores/1599x2398_793a2172-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/1024x1535_793a2172-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/1599x2398_793a2172-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/500x749_793a2172-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/799x1199_793a2172-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2025-12-acores/500x749_793a2172-jpg.jpg",
            "width": 2001
         },
         {
            "faces": [],
            "height": 2001,
            "name": "793A2174.jpg",
            "slug": "793a2174-jpg",
            "src": "/gallery/static/_gallery/albums/2025-12-acores/1600x1067_793a2174-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/1024x683_793a2174-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/1600x1067_793a2174-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/500x333_793a2174-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/800x533_793a2174-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2025-12-acores/500x333_793a2174-jpg.jpg",
            "width": 3000
         },
         {
            "faces": [],
            "height": 2001,
            "name": "793A2184.jpg",
            "slug": "793a2184-jpg",
            "src": "/gallery/static/_gallery/albums/2025-12-acores/1600x1067_793a2184-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/1024x683_793a2184-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/1600x1067_793a2184-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/500x333_793a2184-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/800x533_793a2184-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2025-12-acores/500x333_793a2184-jpg.jpg",
            "width": 3000
         },
         {
            "faces": [],
            "height": 3000,
            "name": "793A2186.jpg",
            "slug": "793a2186-jpg",
            "src": "/gallery/static/_gallery/albums/2025-12-acores/1599x2398_793a2186-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/1024x1535_793a2186-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/1599x2398_793a2186-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/500x749_793a2186-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/799x1199_793a2186-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2025-12-acores/500x749_793a2186-jpg.jpg",
            "width": 2001
         },
         {
            "faces": [],
            "height": 2001,
            "name": "793A2187.jpg",
            "slug": "793a2187-jpg",
            "src": "/gallery/static/_gallery/albums/2025-12-acores/1600x1067_793a2187-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/1024x683_793a2187-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/1600x1067_793a2187-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/500x333_793a2187-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/800x533_793a2187-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2025-12-acores/500x333_793a2187-jpg.jpg",
            "width": 3000
         },
         {
            "faces": [],
            "height": 2001,
            "name": "793A2188.jpg",
            "slug": "793a2188-jpg",
            "src": "/gallery/static/_gallery/albums/2025-12-acores/1600x1067_793a2188-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/1024x683_793a2188-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/1600x1067_793a2188-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/500x333_793a2188-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/800x533_793a2188-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2025-12-acores/500x333_793a2188-jpg.jpg",
            "width": 3000
         },
         {
            "faces": [],
            "height": 2001,
            "name": "793A2206.jpg",
            "slug": "793a2206-jpg",
            "src": "/gallery/static/_gallery/albums/2025-12-acores/1600x1067_793a2206-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/1024x683_793a2206-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/1600x1067_793a2206-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/500x333_793a2206-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/800x533_793a2206-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2025-12-acores/500x333_793a2206-jpg.jpg",
            "width": 3000
         },
         {
            "faces": [],
            "height": 2001,
            "name": "793A2215.jpg",
            "slug": "793a2215-jpg",
            "src": "/gallery/static/_gallery/albums/2025-12-acores/1600x1067_793a2215-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/1024x683_793a2215-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/1600x1067_793a2215-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/500x333_793a2215-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/800x533_793a2215-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2025-12-acores/500x333_793a2215-jpg.jpg",
            "width": 3000
         },
         {
            "faces": [],
            "height": 2001,
            "name": "793A2219.jpg",
            "slug": "793a2219-jpg",
            "src": "/gallery/static/_gallery/albums/2025-12-acores/1600x1067_793a2219-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/1024x683_793a2219-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/1600x1067_793a2219-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/500x333_793a2219-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/800x533_793a2219-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2025-12-acores/500x333_793a2219-jpg.jpg",
            "width": 3000
         },
         {
            "faces": [],
            "height": 2001,
            "name": "793A2224.jpg",
            "slug": "793a2224-jpg",
            "src": "/gallery/static/_gallery/albums/2025-12-acores/1600x1067_793a2224-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/1024x683_793a2224-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/1600x1067_793a2224-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/500x333_793a2224-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/800x533_793a2224-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2025-12-acores/500x333_793a2224-jpg.jpg",
            "width": 3000
         },
         {
            "faces": [],
            "height": 2001,
            "name": "793A2233.jpg",
            "slug": "793a2233-jpg",
            "src": "/gallery/static/_gallery/albums/2025-12-acores/1600x1067_793a2233-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/1024x683_793a2233-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/1600x1067_793a2233-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/500x333_793a2233-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/800x533_793a2233-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2025-12-acores/500x333_793a2233-jpg.jpg",
            "width": 3000
         },
         {
            "faces": [],
            "height": 2001,
            "name": "793A2237.jpg",
            "slug": "793a2237-jpg",
            "src": "/gallery/static/_gallery/albums/2025-12-acores/1600x1067_793a2237-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/1024x683_793a2237-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/1600x1067_793a2237-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/500x333_793a2237-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/800x533_793a2237-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2025-12-acores/500x333_793a2237-jpg.jpg",
            "width": 3000
         },
         {
            "faces": [],
            "height": 2001,
            "name": "793A2244.jpg",
            "slug": "793a2244-jpg",
            "src": "/gallery/static/_gallery/albums/2025-12-acores/1600x1067_793a2244-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/1024x683_793a2244-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/1600x1067_793a2244-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/500x333_793a2244-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/800x533_793a2244-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2025-12-acores/500x333_793a2244-jpg.jpg",
            "width": 3000
         },
         {
            "faces": [],
            "height": 2001,
            "name": "793A2247.jpg",
            "slug": "793a2247-jpg",
            "src": "/gallery/static/_gallery/albums/2025-12-acores/1600x1067_793a2247-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/1024x683_793a2247-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/1600x1067_793a2247-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/500x333_793a2247-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/800x533_793a2247-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2025-12-acores/500x333_793a2247-jpg.jpg",
            "width": 3000
         },
         {
            "faces": [],
            "height": 2001,
            "name": "793A2254.jpg",
            "slug": "793a2254-jpg",
            "src": "/gallery/static/_gallery/albums/2025-12-acores/1600x1067_793a2254-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/1024x683_793a2254-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/1600x1067_793a2254-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/500x333_793a2254-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2025-12-acores/800x533_793a2254-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2025-12-acores/500x333_793a2254-jpg.jpg",
            "width": 3000
         }
      ],
      "slug": "2025-12-acores",
      "src": "/gallery/static/_gallery/albums/2025-12-acores/500x333_793a2129-jpg.jpg"
   },
   "2025-12-porto": {
      "name": "2025.12 - Porto",
      "photos": [
         {
            "faces": [],
            "height": 2001,
            "name": "793A2269.jpg",
            "slug": "793a2269-jpg",
            "src": "/gallery/static/_gallery/albums/2025-12-porto/1600x1067_793a2269-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2025-12-porto/1024x683_793a2269-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2025-12-porto/1600x1067_793a2269-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2025-12-porto/500x333_793a2269-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2025-12-porto/800x533_793a2269-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2025-12-porto/500x333_793a2269-jpg.jpg",
            "width": 3000
         },
         {
            "faces": [],
            "height": 2001,
            "name": "793A2279.jpg",
            "slug": "793a2279-jpg",
            "src": "/gallery/static/_gallery/albums/2025-12-porto/1600x1067_793a2279-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2025-12-porto/1024x683_793a2279-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2025-12-porto/1600x1067_793a2279-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2025-12-porto/500x333_793a2279-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2025-12-porto/800x533_793a2279-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2025-12-porto/500x333_793a2279-jpg.jpg",
            "width": 3000
         },
         {
            "faces": [],
            "height": 2001,
            "name": "793A2282.jpg",
            "slug": "793a2282-jpg",
            "src": "/gallery/static/_gallery/albums/2025-12-porto/1600x1067_793a2282-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2025-12-porto/1024x683_793a2282-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2025-12-porto/1600x1067_793a2282-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2025-12-porto/500x333_793a2282-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2025-12-porto/800x533_793a2282-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2025-12-porto/500x333_793a2282-jpg.jpg",
            "width": 3000
         },
         {
            "faces": [],
            "height": 3000,
            "name": "793A2283.jpg",
            "slug": "793a2283-jpg",
            "src": "/gallery/static/_gallery/albums/2025-12-porto/1599x2398_793a2283-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2025-12-porto/1024x1535_793a2283-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2025-12-porto/1599x2398_793a2283-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2025-12-porto/500x749_793a2283-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2025-12-porto/799x1199_793a2283-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2025-12-porto/500x749_793a2283-jpg.jpg",
            "width": 2001
         },
         {
            "faces": [],
            "height": 2001,
            "name": "793A2286.jpg",
            "slug": "793a2286-jpg",
            "src": "/gallery/static/_gallery/albums/2025-12-porto/1600x1067_793a2286-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2025-12-porto/1024x683_793a2286-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2025-12-porto/1600x1067_793a2286-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2025-12-porto/500x333_793a2286-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2025-12-porto/800x533_793a2286-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2025-12-porto/500x333_793a2286-jpg.jpg",
            "width": 3000
         },
         {
            "faces": [],
            "height": 2001,
            "name": "793A2291.jpg",
            "slug": "793a2291-jpg",
            "src": "/gallery/static/_gallery/albums/2025-12-porto/1600x1067_793a2291-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2025-12-porto/1024x683_793a2291-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2025-12-porto/1600x1067_793a2291-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2025-12-porto/500x333_793a2291-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2025-12-porto/800x533_793a2291-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2025-12-porto/500x333_793a2291-jpg.jpg",
            "width": 3000
         },
         {
            "faces": [],
            "height": 3000,
            "name": "793A2296.jpg",
            "slug": "793a2296-jpg",
            "src": "/gallery/static/_gallery/albums/2025-12-porto/1599x2398_793a2296-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2025-12-porto/1024x1535_793a2296-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2025-12-porto/1599x2398_793a2296-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2025-12-porto/500x749_793a2296-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2025-12-porto/799x1199_793a2296-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2025-12-porto/500x749_793a2296-jpg.jpg",
            "width": 2001
         },
         {
            "faces": [],
            "height": 2001,
            "name": "793A2299.jpg",
            "slug": "793a2299-jpg",
            "src": "/gallery/static/_gallery/albums/2025-12-porto/1600x1067_793a2299-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2025-12-porto/1024x683_793a2299-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2025-12-porto/1600x1067_793a2299-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2025-12-porto/500x333_793a2299-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2025-12-porto/800x533_793a2299-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2025-12-porto/500x333_793a2299-jpg.jpg",
            "width": 3000
         },
         {
            "faces": [],
            "height": 2001,
            "name": "793A2301.jpg",
            "slug": "793a2301-jpg",
            "src": "/gallery/static/_gallery/albums/2025-12-porto/1600x1067_793a2301-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2025-12-porto/1024x683_793a2301-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2025-12-porto/1600x1067_793a2301-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2025-12-porto/500x333_793a2301-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2025-12-porto/800x533_793a2301-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2025-12-porto/500x333_793a2301-jpg.jpg",
            "width": 3000
         },
         {
            "faces": [],
            "height": 3000,
            "name": "793A2335.jpg",
            "slug": "793a2335-jpg",
            "src": "/gallery/static/_gallery/albums/2025-12-porto/1599x2398_793a2335-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2025-12-porto/1024x1535_793a2335-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2025-12-porto/1599x2398_793a2335-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2025-12-porto/500x749_793a2335-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2025-12-porto/799x1199_793a2335-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2025-12-porto/500x749_793a2335-jpg.jpg",
            "width": 2001
         },
         {
            "faces": [],
            "height": 3000,
            "name": "793A2336.jpg",
            "slug": "793a2336-jpg",
            "src": "/gallery/static/_gallery/albums/2025-12-porto/1599x2429_793a2336-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2025-12-porto/1024x1554_793a2336-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2025-12-porto/1599x2429_793a2336-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2025-12-porto/500x759_793a2336-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2025-12-porto/799x1214_793a2336-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2025-12-porto/500x759_793a2336-jpg.jpg",
            "width": 1976
         },
         {
            "faces": [],
            "height": 3000,
            "name": "793A2341.jpg",
            "slug": "793a2341-jpg",
            "src": "/gallery/static/_gallery/albums/2025-12-porto/1599x2398_793a2341-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2025-12-porto/1024x1535_793a2341-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2025-12-porto/1599x2398_793a2341-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2025-12-porto/500x749_793a2341-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2025-12-porto/799x1199_793a2341-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2025-12-porto/500x749_793a2341-jpg.jpg",
            "width": 2001
         }
      ],
      "slug": "2025-12-porto",
      "src": "/gallery/static/_gallery/albums/2025-12-porto/500x333_793a2269-jpg.jpg"
   },
   "2025-12-vallee-de-douro": {
      "name": "2025.12 - Vall\u00e9e de Douro",
      "photos": [
         {
            "faces": [],
            "height": 2001,
            "name": "793A2347.jpg",
            "slug": "793a2347-jpg",
            "src": "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/1600x1067_793a2347-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/1024x683_793a2347-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/1600x1067_793a2347-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/500x333_793a2347-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/800x533_793a2347-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/500x333_793a2347-jpg.jpg",
            "width": 3000
         },
         {
            "faces": [],
            "height": 3000,
            "name": "793A2356.jpg",
            "slug": "793a2356-jpg",
            "src": "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/1599x2398_793a2356-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/1024x1535_793a2356-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/1599x2398_793a2356-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/500x749_793a2356-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/799x1199_793a2356-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/500x749_793a2356-jpg.jpg",
            "width": 2001
         },
         {
            "faces": [],
            "height": 2001,
            "name": "793A2358.jpg",
            "slug": "793a2358-jpg",
            "src": "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/1600x1067_793a2358-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/1024x683_793a2358-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/1600x1067_793a2358-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/500x333_793a2358-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/800x533_793a2358-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/500x333_793a2358-jpg.jpg",
            "width": 3000
         },
         {
            "faces": [],
            "height": 2001,
            "name": "793A2361.jpg",
            "slug": "793a2361-jpg",
            "src": "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/1600x1067_793a2361-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/1024x683_793a2361-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/1600x1067_793a2361-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/500x333_793a2361-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/800x533_793a2361-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/500x333_793a2361-jpg.jpg",
            "width": 3000
         },
         {
            "faces": [],
            "height": 2001,
            "name": "793A2363.jpg",
            "slug": "793a2363-jpg",
            "src": "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/1600x1067_793a2363-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/1024x683_793a2363-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/1600x1067_793a2363-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/500x333_793a2363-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/800x533_793a2363-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/500x333_793a2363-jpg.jpg",
            "width": 3000
         },
         {
            "faces": [],
            "height": 2001,
            "name": "793A2368.jpg",
            "slug": "793a2368-jpg",
            "src": "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/1600x1067_793a2368-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/1024x683_793a2368-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/1600x1067_793a2368-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/500x333_793a2368-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/800x533_793a2368-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/500x333_793a2368-jpg.jpg",
            "width": 3000
         },
         {
            "faces": [],
            "height": 3000,
            "name": "793A2371.jpg",
            "slug": "793a2371-jpg",
            "src": "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/1599x2398_793a2371-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/1024x1535_793a2371-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/1599x2398_793a2371-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/500x749_793a2371-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/799x1199_793a2371-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/500x749_793a2371-jpg.jpg",
            "width": 2001
         },
         {
            "faces": [],
            "height": 2001,
            "name": "793A2376.jpg",
            "slug": "793a2376-jpg",
            "src": "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/1600x1067_793a2376-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/1024x683_793a2376-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/1600x1067_793a2376-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/500x333_793a2376-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/800x533_793a2376-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/500x333_793a2376-jpg.jpg",
            "width": 3000
         },
         {
            "faces": [],
            "height": 2001,
            "name": "793A2378.jpg",
            "slug": "793a2378-jpg",
            "src": "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/1600x1067_793a2378-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/1024x683_793a2378-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/1600x1067_793a2378-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/500x333_793a2378-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/800x533_793a2378-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/500x333_793a2378-jpg.jpg",
            "width": 3000
         },
         {
            "faces": [],
            "height": 2001,
            "name": "793A2381.jpg",
            "slug": "793a2381-jpg",
            "src": "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/1600x1067_793a2381-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/1024x683_793a2381-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/1600x1067_793a2381-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/500x333_793a2381-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/800x533_793a2381-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/500x333_793a2381-jpg.jpg",
            "width": 3000
         },
         {
            "faces": [],
            "height": 2001,
            "name": "793A2384.jpg",
            "slug": "793a2384-jpg",
            "src": "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/1600x1067_793a2384-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/1024x683_793a2384-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/1600x1067_793a2384-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/500x333_793a2384-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/800x533_793a2384-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/500x333_793a2384-jpg.jpg",
            "width": 3000
         },
         {
            "faces": [],
            "height": 2001,
            "name": "793A2386.jpg",
            "slug": "793a2386-jpg",
            "src": "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/1600x1067_793a2386-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/1024x683_793a2386-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/1600x1067_793a2386-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/500x333_793a2386-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/800x533_793a2386-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/500x333_793a2386-jpg.jpg",
            "width": 3000
         },
         {
            "faces": [],
            "height": 2001,
            "name": "793A2390.jpg",
            "slug": "793a2390-jpg",
            "src": "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/1600x1067_793a2390-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/1024x683_793a2390-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/1600x1067_793a2390-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/500x333_793a2390-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/800x533_793a2390-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/500x333_793a2390-jpg.jpg",
            "width": 3000
         },
         {
            "faces": [],
            "height": 2001,
            "name": "793A2393.jpg",
            "slug": "793a2393-jpg",
            "src": "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/1600x1067_793a2393-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/1024x683_793a2393-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/1600x1067_793a2393-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/500x333_793a2393-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/800x533_793a2393-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/500x333_793a2393-jpg.jpg",
            "width": 3000
         },
         {
            "faces": [],
            "height": 2001,
            "name": "793A2403.jpg",
            "slug": "793a2403-jpg",
            "src": "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/1600x1067_793a2403-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/1024x683_793a2403-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/1600x1067_793a2403-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/500x333_793a2403-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/800x533_793a2403-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/500x333_793a2403-jpg.jpg",
            "width": 3000
         },
         {
            "faces": [],
            "height": 2001,
            "name": "793A2406.jpg",
            "slug": "793a2406-jpg",
            "src": "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/1600x1067_793a2406-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/1024x683_793a2406-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/1600x1067_793a2406-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/500x333_793a2406-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/800x533_793a2406-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/500x333_793a2406-jpg.jpg",
            "width": 3000
         },
         {
            "faces": [],
            "height": 2001,
            "name": "793A2409.jpg",
            "slug": "793a2409-jpg",
            "src": "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/1600x1067_793a2409-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/1024x683_793a2409-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/1600x1067_793a2409-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/500x333_793a2409-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/800x533_793a2409-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/500x333_793a2409-jpg.jpg",
            "width": 3000
         },
         {
            "faces": [],
            "height": 2001,
            "name": "793A2411.jpg",
            "slug": "793a2411-jpg",
            "src": "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/1600x1067_793a2411-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/1024x683_793a2411-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/1600x1067_793a2411-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/500x333_793a2411-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/800x533_793a2411-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/500x333_793a2411-jpg.jpg",
            "width": 3000
         },
         {
            "faces": [],
            "height": 2001,
            "name": "793A2414.jpg",
            "slug": "793a2414-jpg",
            "src": "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/1600x1067_793a2414-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/1024x683_793a2414-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/1600x1067_793a2414-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/500x333_793a2414-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/800x533_793a2414-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/500x333_793a2414-jpg.jpg",
            "width": 3000
         },
         {
            "faces": [],
            "height": 2001,
            "name": "793A2417.jpg",
            "slug": "793a2417-jpg",
            "src": "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/1600x1067_793a2417-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/1024x683_793a2417-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/1600x1067_793a2417-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/500x333_793a2417-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/800x533_793a2417-jpg.jpg"
               ]
            },
            "thumb": "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/500x333_793a2417-jpg.jpg",
            "width": 3000
         }
      ],
      "slug": "2025-12-vallee-de-douro",
      "src": "/gallery/static/_gallery/albums/2025-12-vallee-de-douro/500x333_793a2347-jpg.jpg"
   }
};